import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
// import { Mail, Phone, MapPin } from 'lucide-react';

import { getMenuLevelsData } from "../../../store/slices/menuSlice";
import { redirectURL } from "utils/helper/helper";
import { useDispatch, useSelector } from "react-redux";

import axiosInstance from "../../../../src/utils/api/axiosInstance";
import { SETTING_ROUTE } from "../../../../src/utils/api/routes/serverRoute";
import { FOOTER_ROUTE } from "utils/api/routes/clientRoute";
import { getAllMenuWithSubMenuAPI } from "../../../utils/api/service/menuService";
import { getMenuListingAction } from "../../../store/slices/menuSlice";

import footer_bg from "../../../assets/images/footer-bg.jpg";
import { getGlobalSettingsData } from "store/slices/profileSlice";

export const getAllSettingsAPI = () => {
  return axiosInstance.get(`${SETTING_ROUTE.GET_GLOBAL_SETTINGS}`);
};

const Footer = () => {
  const footerData = useSelector(getMenuLevelsData);
  const globalSetting = useSelector(getGlobalSettingsData);
  const navigate = useNavigate();
  const dispatch = useDispatch();


  useEffect(() => {
    const getAllMenusDataHandler = async () => {
      try {
        const { data } = await getAllMenuWithSubMenuAPI();
        dispatch(getMenuListingAction(data.data));
      } catch {
        console.log("Unable to get All menus data");
      }
    };
    getAllMenusDataHandler();
  }, []);


  return (
    <div>
      <footer style={{ backgroundImage: "url(" + footer_bg + ")" }}>
        <div className="container">
          <div className="footer-top">
            <div className="row text-center text-lg-start">

              {/* Column 1 */}
              <div className="col-12 col-md-6 col-lg-4 footer-logo-widget mb-4">
                <a
                  href="/"
                  className="d-flex justify-content-center justify-content-lg-start align-items-center mb-3 text-decoration-none"
                >
                  <img
                    src={globalSetting?.logoImage || "/logo2.png"}
                    alt="Footer logo"
                    style={{ width: "150px", height: "50px" }}
                  />
                </a>

                <p>{globalSetting?.tagLine ?? ""}</p>

                <ul className="list-unstyled d-flex justify-content-center justify-content-lg-start footer-social">
                  <li className="me-3">
                    <a target="blank" href={globalSetting?.facebookLink}>
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li>
                  <li className="me-3">
                    <a target="blank" href={globalSetting?.youtubeLink}>
                      <i className="fab fa-youtube"></i>
                    </a>
                  </li>
                  <li className="me-3">
                    <a target="blank" href={globalSetting?.instaLink}>
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a target="blank" href={globalSetting?.linkdinLink}>
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                  </li>
                </ul>
              </div>

              {/* Column 2 */}
              <div className="col-12 col-md-6 col-lg-4 footer-logo-widget mb-4">
                <ul className="category-ul text-center text-lg-start">
                  {footerData?.level3?.map((footerItem, index) => (
                    footerItem.footerMenuLevel === "horizontal" && (
                      <li key={index} className="category-li">
                        <h6
                          className="cursor-pointer"
                          onClick={() =>
                            footerItem?.menu?.isMenuDeeplink
                              ? navigate(footerItem?.menu.deepLink)
                              : navigate(
                                `${FOOTER_ROUTE.LINKS.replace(
                                  ":footerMenu",
                                  footerItem?.menu?.slug
                                ).replace(
                                  ":footerSubmenu",
                                  footerItem?.menu?.slug
                                )}`
                              )
                          }
                        >
                          {footerItem?.menu?.menuName}
                        </h6>

                        <ul>
                          {footerItem?.subMenu?.map((item, i) => (
                            <li key={i} className="cursor-pointer">
                              <a
                                onClick={() =>
                                  item.isMenuDeeplink
                                    ? redirectURL(item.deepLink)
                                    : navigate(
                                      `${FOOTER_ROUTE.LINKS.replace(
                                        ":footerMenu",
                                        footerItem?.menu?.slug
                                      ).replace(":footerSubmenu", item?.slug)}`
                                    )
                                }
                              >
                                {item?.menuName}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </li>
                    )
                  ))}
                </ul>
              </div>

              {/* Column 3 */}
              <div className="col-12 col-md-12 col-lg-4 footer-logo-widget mb-4 text-center text-lg-start">
                <div className="space-y-3">

                  <div>
                    <span className="fw-bold">Email:</span><br />
                    <span>Info@trexpower.ai</span>
                  </div>

                  <div>
                    <span className="fw-bold">Phone:</span><br />
                    <span>+91 9321698246</span>
                  </div>

                  <div>
                    <span className="fw-bold">Address:</span><br />
                    <span>
                      S. No. 371/A/13/6, Lotus Industrial Park <br />
                      Near Vasai Phata
                    </span>
                  </div>

                </div>
              </div>

            </div>
          </div>



          <div className="copyright text-center mt-3">
            {globalSetting?.copyright && <p>{globalSetting?.copyright}</p>}
            {!globalSetting?.copyright && (
              <p>
                &copy; {new Date().getFullYear() ?? ""} All rights reserved.
              </p>
            )}
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
